import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadProjectList,
  loadDeploymentList,
  loadBuildingsList,
  loadFloorsList,
  loadRoomsList,
  loadDeviceList,
  getDeployment,
} from "../../../actions/adminAction";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import Projects from "./Projects";
import Deployments from "../deployments/Deployments";
import Devices from "../devices/Devices";
import PropTypes from "prop-types";

const ProjectConfig = () => {
  const projectsList = useSelector((state) => state.admin.projectsList);
  const projectListLoading = useSelector(
    (state) => state.admin.projectListLoading
  );
  // const selectedProject = useSelector((state)=>state.admin.project);
  const buildingsList = useSelector((state) => state.admin.buildingsList);
  const buildingListLoading = useSelector(
    (state) => state.admin.buildingListLoading
  );
  const floorsList = useSelector((state) => state.admin.floorsList);
  const floorListLoading = useSelector((state) => state.admin.floorListLoading);
  const roomsList = useSelector((state) => state.admin.roomsList);
  const roomListLoading = useSelector((state) => state.admin.roomListLoading);
  const deploymentsList = useSelector((state) => state.admin.deploymentsList);
  const deploymentListLoading = useSelector(
    (state) => state.admin.deploymentListLoading
  );
  const devicesList = useSelector((state) => state.admin.devicesList);
  const deviceListLoading = useSelector(
    (state) => state.admin.deploymentListLoading
  );

  const dark = useSelector((state) => state.dark.data);
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();

  function handleChangeTab(event, newValue) {
    setActiveTab(newValue);
  }

  // Set Tabs props
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3, bgcolor: "#072545", color: "white" }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  // Load project list
  useEffect(() => {
    if (projectsList.length === 0 && projectListLoading) {
      dispatch(loadProjectList());
    }
  }, []);

   // Load project list, deployment and device list when active tab set
   useEffect(() => {
    if (activeTab===0) {
      dispatch(loadProjectList());
    }
    else if(activeTab ===1){
      dispatch(loadDeploymentList());
    }
  }, [activeTab]);

  // Load deployment list
  useEffect(() => {
    if (deploymentsList.length === 0 && deploymentListLoading) {
      dispatch(loadDeploymentList());
    }
  }, []);

  // Load building list
  useEffect(() => {
    if (buildingsList.length === 0 && buildingListLoading) {
      dispatch(loadBuildingsList());
    }
  }, []);

  // Load floor list
  useEffect(() => {
    if (floorsList.length === 0 && floorListLoading) {
      dispatch(loadFloorsList());
    }
  }, []);

  // Load room list
  useEffect(() => {
    dispatch(loadRoomsList());
  }, []);

  // Load device list
  useEffect(() => {
    if (devicesList.length === 0 && deviceListLoading) {
      dispatch(loadDeviceList());
    }
  }, []);


  return (
    <>
      <div className="px-sm-5 px-2 admin-margin w-100 d-flex flex-column my-4 overflow-auto">
        {/* Project Count Header */}
        <div className="d-flex align-items-center">
          {activeTab === 0 ? (
            <>
              <h6 className="text-main mb-0">Admin / Projects</h6>
              <div className="rounded-pill text-main admin-list-btn-primary admin-list-count px-2 py-1 align-self-center mx-2 my-2 caption ">
                {projectsList.data?.length}
              </div>
            </>
          ) : activeTab === 1 ? (
            <>
              <h6 className="text-main mb-0">Admin / Deployments</h6>
              <div className="rounded-pill text-main admin-list-btn-primary admin-list-count px-2 py-1 align-self-center mx-2 my-2 caption ">
                {deploymentsList.data?.length}
              </div>
            </>
          ) : (
            <>
              <h6 className="text-main mb-0">Admin / Device</h6>
              <div className="rounded-pill text-main admin-list-btn-primary admin-list-count px-2 py-1 align-self-center mx-2 my-2 caption ">
                {devicesList.data?.length}
              </div>
            </>
          )}
        </div>
        <div className="mb-2" style={{ backgroundColor: "#072545" }}>
          {/* Content */}
          <Box sx={{ width: "100%" }}>
            {/* Navigation Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={activeTab}
                onChange={handleChangeTab}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Project"
                  {...a11yProps(0)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={<FeedOutlinedIcon sx={{ color: "white" }} />}
                  aria-label="project"
                  iconPosition="top"
                />
                <Tab
                  label="Deployment"
                  {...a11yProps(1)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={<RocketLaunchOutlinedIcon sx={{ color: "white" }} />}
                  aria-label="project"
                  iconPosition="top"
                />
                <Tab
                  label="Device"
                  {...a11yProps(2)}
                  sx={{ color: "white", fontSize: "10px" }}
                  icon={<SmartToyOutlinedIcon sx={{ color: "white" }} />}
                  aria-label="project"
                  iconPosition="top"
                />
              </Tabs>
            </Box>
            {/* Project */}
            <CustomTabPanel value={activeTab} index={0}>
              <Projects setActiveTab={setActiveTab}  />
            </CustomTabPanel>
            {/* Deployment */}
            <CustomTabPanel value={activeTab} index={1}>
              <Deployments setActiveTab={setActiveTab} />
            </CustomTabPanel>
            {/* Device */}
            <CustomTabPanel value={activeTab} index={2}>
              <Devices />
            </CustomTabPanel>
          </Box>

          {/* Configuration Navigation Tab */}
        </div>
      </div>
    </>
  );
};

export default ProjectConfig;
